enum DealStageType {
  DEFAULT = "default",
  WON = "won",
  LOST = "lost",
}

export default DealStageType;
